import Vue from 'vue';
import Vuex from 'vuex';
import storePlugins from "@/plugins/storePlugins";


Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [storePlugins],
  state: {
    layout: 'loading',
    menu: true,
    loading: false,
    loggedIn: false,
    loggedUsername: 'U',
    userData: null,
    warehouse: '',
    warehouses: [],
    warehousesRaw: [],
    snackbarProps: {
      visible: false,
      bottom: false,
      color: 'success',
      left: false,
      multiline: true,
      right: true,
      timeout: 2000,
      top: true,
      vertical: false,
      text: ''
    },
    addresses: [
        {code: 1842, text: "MEXICO - SAN LUIS POTOSÍ"},
        {code: 1828, text: "MEXICO - SAN LUIS POTOSÍ"},
        {code: 340, text: "MEXICO - GUANAJUATO"},
        {code: 986, text: "MEXICO - NUEVO LEÓN"},
        {code: 1869, text: "MEXICO - SAN LUIS POTOSÍ"},
        {code: 966, text: "MEXICO - NUEVO LEÓN"},
        {code: 232, text: "MEXICO - Ciudad de México"},
        {code: 225, text: "MEXICO - Ciudad de México"},
        {code: 226, text: "MEXICO - Ciudad de México"},
        {code: 230, text: "MEXICO - Ciudad de México"},
        {code: 651, text: "MEXICO - JALISCO"},
        {code: 220, text: "MEXICO -  CIUDAD DE MÉXICO"},
        {code: 273, text: "MEXICO -  COLIMA"},
        {code: 760, text: "MEXICO -  MÉXICO"},
    ],
  },
  mutations: {
  },
  actions: {
    tstAction(){
      console.log("aa");
      //router.push('/about');
    },

    /**
     * Open snackbar with success status
     * @param {*} _ dispatch data
     * @param {string} message Message to show
     */
    snackbarSuccess(_,message){
      this.state.snackbarProps.visible = true
      this.state.snackbarProps.color = 'success'
      this.state.snackbarProps.text = message;
    },

    /**
     * Open snackbar with error status
     * @param {*} _ dispatch data
     * @param {string} message Message to show
     */
     snackbarError(_,message){
      this.state.snackbarProps.visible = true
      this.state.snackbarProps.color = 'error'
      this.state.snackbarProps.text = message;
    }


  },
  modules: {
  }
})
